import AlIFramePreviewController from './controller';
import templateUrl from './component.tpl.html';

angular
    .module('festzelt-os.modules.core')
    .component('alIframePreview', {
        controller: AlIFramePreviewController,
        controllerAs: 'vm',
        bindings: {
            content: '<',
            marginTop: '<',
            viewPort: '<'
        },
        templateUrl
    })



// WEBPACK FOOTER //
// ./src/app/modules/core/components/al-iframe-preview/component.js